module.exports = __webpack_public_path__ + "assets/img/travel-day9.2252e4a7.png";